import ShoppingCart from './shopping-cart';

export default class ProductsShoppingCart {
  constructor(selectors, shoppingCart) {
    this.selectors = selectors;
    this.shoppingCart = shoppingCart;

    this.shoppingCartProducts = $(selectors.shoppingCartProducts);
    this.noProductsInCart = $(selectors.noProductsInCart);

    this.addToShoppingCartButtons = $(selectors.addToShoppingCartButtons);
    this.goToFormButton = $(selectors.goToFormButton);
  }

  initializeShoppingCartProducts() {
    const products = this.shoppingCart.getProducts();

    if (!products) {
      return;
    }
  
    if (products.length > 0) {
      this.noProductsInCart.hide();
      this.goToFormButton.show().css('display', 'inline-block');
    }

    for (let x = 0; x < products.length; x += 1) {
      const product = products[x];
      this.addProductToShoppingCart(product);
    }

    this.shoppingCart.updateMobileInfo();
  }

  addProductToShoppingCart(product) {
    let liter = '';

    if (/^\d+$/.test(product.volume)) {
      liter = ' liter';
    }

    const template = `
      <div data-id="${product.id}" class="shopping-cart-product">
        <h6>${product.title}</h6>
        <p><span class="quantity">${product.quantity}</span> st, ${product.volume} ${liter}, ledigingsfrequentie: ${product.frequency}</p>
        <button class="btn-remove-product btn btn-link"><i class="fas fa-times"></i></button>
      </div>
    `;

    const productNode = $(template);
    productNode.hide();

    this.shoppingCartProducts.append(productNode);
    productNode.fadeIn(200);
  }

  addAlert(message) {
    const template = `
      <div class="alert alert-danger" role="alert">
        ${message}
      </div>
    `;

    this.shoppingCartProducts.append($(template));
  }
  
  initializeClickHandlers() {
    this.addToShoppingCartButtons.on('click', (e) => {
      const button = $(e.currentTarget);
      const product = button.parentsUntil('.product').parent();

      const quantity = product.find('select.quantity');
      const volume = product.find('select.volume');
      const alertProductAdded = product.find('.alert-product-added');

      // Sometimes product do not have any frequencies so find the backup value.
      let frequency = product.find("input[type='hidden'].frequency");
      if (product.find('select.frequency').length) {
        frequency = product.find('select.frequency');
      }

      ProductsShoppingCart.hideSuccessMessage(alertProductAdded);
      
      const productData = {
        id: product.data('id'),
        title: product.data('title'),
        url: product.data('url'),
        wasteType: product.data('waste-type-names'),
        quantity: quantity.val(),
        frequency: frequency.val(),
        volume: volume.val(),
      };

      const result = this.shoppingCart.addProduct(productData);

      if (!result.success) {
        this.addAlert(result.message);
      } else if (result.updated) {
        const products = this.shoppingCart.getProducts();
        const indexOfExistingProduct = ShoppingCart.getIndexOfProductInProducts(productData,
          products);

        const productNodes = $('.shopping-cart-product');

        if (productNodes && productNodes.length) {
          $(productNodes[indexOfExistingProduct]).find('.quantity').text(products[indexOfExistingProduct].quantity).fadeOut(50)
            .fadeIn(250);

          ProductsShoppingCart.showSuccessMessageIfNecessary(alertProductAdded);
        }
      } else {
        this.addProductToShoppingCart(productData);
        this.noProductsInCart.hide();
        this.goToFormButton.show().css('display', 'inline-block');

        ProductsShoppingCart.showSuccessMessageIfNecessary(alertProductAdded);
      }
    });

    this.shoppingCartProducts.on('click', '.btn-remove-product', (e) => {
      const button = $(e.currentTarget);
      const productNode = button.parent();
      const myIndexInShoppingCart = productNode.index();

      this.shoppingCart.removeProductAtIndex(myIndexInShoppingCart);

      productNode.fadeOut(400, () => {
        productNode.remove();
        if (!this.shoppingCart.hasProducts()) {
          this.noProductsInCart.fadeIn(200);
          this.goToFormButton.hide();
        }
      });
    });
  }

  static hideSuccessMessage(alert) {
    if ($(window).width() < 992) {
      alert.fadeOut(200);
    }
  }

  static showSuccessMessageIfNecessary(alert) {
    if ($(window).width() < 992) {
      alert.fadeIn(200);
    }
  }
}
